<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>供应点管理</el-breadcrumb-item>
        <el-breadcrumb-item>领货管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="领货日期：">
              <el-select clearable style="width: 100%" v-model="listParams.date" placeholder="请选择领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.dateId" :key="item.dateId" :label="item.date | formatDate"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input size="small" v-model="listParams.orderNo" placeholder="请输入订单编号"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="手机号码：" prop="mobile">
              <el-input size="small" v-model="listParams.mobile" placeholder="请输入手机号码"> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData('init')"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <!--<el-button-->
          <!--class="align-left"-->
          <!--type="primary"-->
          <!--size="small"-->
          <!--@click="printList">-->
          <!--打印-->
          <!--</el-button>-->
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="mobile" align="center" label="手机号"> </el-table-column>

        <el-table-column prop="date" align="center" label="供应日期">
          <template slot-scope="scope">
            <span>{{ scope.row.date | formatDate }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="areaNo" align="center" label="位置号"> </el-table-column>

        <el-table-column prop="orderNo" align="center" label="订单编号">
          <template slot-scope="scope">
            <div v-if="scope.row.orderNo">
              <div v-if="scope.row.orderNo.length > 10">
                <el-popover ref="popover1" placement="top-start" width="200" trigger="hover" :content="scope.row.orderNo"> </el-popover>
                <el-button style="color: #606266" type="text" v-popover:popover1>
                  {{ scope.row.orderNo | formatLimitLength }}
                </el-button>
              </div>
              <div v-else>
                {{ scope.row.orderNo }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="goodTitle" align="center" label="菜品名称"> </el-table-column>

        <el-table-column prop="specTitle" align="center" label="规格"> </el-table-column>

        <el-table-column prop="quantity" align="center" label="数量"> </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="供应点名称 ：" prop="supplyCentreName">
            <el-input v-model="itemParams.supplyCentreName" size="small" placeholder="请输入供应点名称"> </el-input>
          </el-form-item>

          <el-form-item label="供应点地址 ：" prop="supplyCentreAddr">
            <el-input v-model="itemParams.supplyCentreAddr" size="small" placeholder="请输入供应点地址"> </el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="saveSupplyCentre"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        supplyId: "",
        id: "",
        date: "",
        orderNo: "",
        mobile: "",
      },
      dateList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "新增供应点",
      dialogVisible: false,
      itemParams: {
        supplyCentreName: "",
        supplyCentreAddr: "",
      },
      checkItemParams: {
        supplyCentreName: [{ required: true, message: "请输入供应点名称", trigger: "blur" }],
        supplyCentreAddr: [{ required: true, message: "请输入供应点地址", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.listParams.id = this.$route.params.supplyCentreId;
    this.loadDateList();
  },
  methods: {
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/logistics/goods-management-date",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dateList = res.body.data.dateList;
              this.listParams.date = res.body.data.dateList[0].dateId;
              this.loadTableData();
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData(init) {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      });
      if (init) {
        bodyParams.pageIndex = 1;
      }
      this.$http({
        url: global.apiUrl + "/logistics/goods-management",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 打印
     */
    printList() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 保存新增或修改
     */
    saveSupplyCentre() {},
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
